import { createStyles, makeStyles, withStyles, Theme } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import Colors from '../Colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartBar: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexFlow: 'column',
        padding: '10px 0 10px 0',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'space-around',
        padding: '10px 0 10px 0',
      },
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'space-around',
        padding: '10px 0 10px 0',
      },
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-around',
        padding: '10px 0 10px 0',
      },
      alignItems: 'center',
      width: '100%',
      background: Colors.secundary,
      padding: '5px 0 5px 0',
    },
    root: {
      boxSizing: 'border-box',
      margin: '10px 25px',
      minWidth: '50%',
      maxWidth: '100%',
      maxHeight: 550,
      backgroundColor: '#fff',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
      },
    },
    title: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9em',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.1em',
      },

      color: Colors.tertiary,
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '1.1em',
      lineHeight: '1.313em',
      fontFamily: 'Roboto',
    },
    cardContent: {
      height: '100%',
      [theme.breakpoints.down('xs')]: {
        overflow: 'auto',
      },
    },
    containerFormControl: {
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        flexFlow: 'column',
        alignItems: 'center',
      },
    },
    formControl: {
      margin: '5% 5% 0 0',
      height: 35,
      backgroundColor: 'white',
      borderRadius: '5px',
      '&:last-child': {
        marginRight: 0,
      },
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
      },
    },
    formControlSelect: {
      width: '25%',
      padding: '0 2% 0 2%',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
  }),
);

